/// rounded-rectangle-layer-fragment.js
// This is copied and adapted from scatterplot-layer-fragment.glsl.js
// Modifications are annotated
export default `\
#version 300 es
#define SHADER_NAME rounded-rectangle-layer-fragment-shader

precision highp float;

uniform float cornerRadius;

in vec4 vFillColor;
in vec4 vLineColor;
in vec2 unitPosition;
in float innerUnitRadius;
in float outerRadiusPixels;

out vec4 fragColor;

void main(void) {
    // Check if inside the rounded rectangle area
    float rectangleRoundedCorner = innerUnitRadius * (sqrt(2.0) * (1.0 - cornerRadius) + 1.0 * cornerRadius);
    float borderRounderCorner = sqrt(2.0) * (1.0 - cornerRadius) + 1.0 * cornerRadius;
    float distanceToCenter = length(unitPosition);
    if (abs(unitPosition.x) <= innerUnitRadius && abs(unitPosition.y) <= innerUnitRadius && distanceToCenter <= rectangleRoundedCorner) {
        fragColor = vFillColor; // Fill color for the inside
    } else {
        // Check for border area
        float borderThreshold = 1.0;
        if (abs(unitPosition.x) <= borderThreshold && abs(unitPosition.y) <= borderThreshold && distanceToCenter <= borderRounderCorner) {
            fragColor = vLineColor; // Line color for the border
        } else {
            discard; // Discard fragments outside the rectangle
        }
    }

    // Optionally handle picking
    fragColor = picking_filterHighlightColor(fragColor);
    fragColor = picking_filterPickingColor(fragColor);
}
`;
